import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Table, Pagination, Form, Modal, Icon, Spin } from "antd";
import { getSignUps, deleteSignUps } from '../../actions/SignUpsAction';

const confirm = Modal.confirm;

class SignUps extends React.Component {

    state = {
        pageNumber: 1
    };

    componentDidMount() {
        const { pageNumber } = this.state;
        const { mainPartnerId } = this.props.affiliates;

        mainPartnerId && this.props.dispatch(getSignUps(mainPartnerId, pageNumber));
    }

    onPageChange = (current) => {
        this.setState({ pageNumber: current });
    }

    // On page change get new data
    componentDidUpdate(prevProps, prevState) {
        const { pageNumber } = this.state;
        const { mainPartnerId } = this.props.affiliates;

        if (prevState.pageNumber !== pageNumber || prevProps.affiliates.mainPartnerId !== mainPartnerId) {
            this.props.dispatch(getSignUps(mainPartnerId, pageNumber));
        }
    }

    handleDeleteSignUps = (e, row, index) => {
        const { pageNumber } = this.state;
        const { mainPartnerId } = this.props.affiliates;

        const that = this;

        confirm({
            title: this.props.intl.messages.delete,
            content: <div className="ta--footer-delete-item ">
                <p className='ta--pb-0'>{this.props.intl.messages.confirm_user_delete}</p>
            </div>,
            okText: this.props.intl.messages.delete,
            onOk() {
                that.props.dispatch(deleteSignUps(row.id, that.props.intl)).then(() =>
                    that.props.dispatch(getSignUps(mainPartnerId, pageNumber))
                )
            },
            onCancel() {
            },
        });
    };

    render() {
        const { signUps } = this.props.signUps;

        const sorter = (a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
            }
            return 0;
        };

        const columns = [
            {
                title: this.props.intl.messages.name,
                dataIndex: 'name',
                key: 'name',
                filters: [],
                sorter: sorter,
                sortDirections: ['ascend' , 'descend'],
            },
            {
                title: this.props.intl.messages.surname,
                dataIndex: 'surname',
                key: 'surname',
            },
            {
                title: this.props.intl.messages.referral_id,
                dataIndex: 'referral_id',
                key: 'referral_id',
            },
            {
                title: this.props.intl.messages.company_name,
                dataIndex: 'company_name',
                key: 'company_name',
            },
            {
                title: this.props.intl.messages.email,
                dataIndex: 'email',
                key: 'email',
            },
            {
                title: this.props.intl.messages.phone_number,
                dataIndex: 'phone_number',
                key: 'phone_number',
            },
            {
                title: '',
                dataIndex: 'settings',
                key: 'settings',
                width: '30px',
                render: (value, row, index) => (
                    <div>
                        <i onClick={(e) => this.handleDeleteSignUps(e, row, index)} className='delete-icon ta--f-20'></i>
                    </div>
                ),
            },
        ];

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        let tableData = [];
        if (signUps && signUps.UserOrders) {
            tableData = Object.keys(signUps.UserOrders).map(key => {
                return {
                    name: signUps.UserOrders[key].Name,
                    surname: signUps.UserOrders[key].SurName,
                    referral_id: signUps.UserOrders[key].ReferralId,
                    company_name: signUps.UserOrders[key].CompanyName,
                    email: signUps.UserOrders[key].Email,
                    phone_number: signUps.UserOrders[key].PhoneNumber,
                    id: signUps.UserOrders[key].Id,
                    key: signUps.UserOrders[key].Id,
                }
            }).sort(sorter);
        }

        return (
            <div>
                <h2 className='ta--main-header'>{this.props.intl.messages.sign_ups}</h2>

                <Spin indicator={antIcon} spinning={this.props.signUps.inProcess}>
                    <Table
                        dataSource={tableData.sort(sorter)}
                        columns={columns}
                        pagination={false}
                        className="ta-aff-table ta--mt-8"
                        footer={() => <div className='ta--pagination-rows'>{this.props.intl.messages.total_rows}:{signUps && signUps.RowCount}</div>}
                    >
                    </Table>
                    <Pagination defaultCurrent={1} pageSize={13} total={signUps && signUps.RowCount} onChange={this.onPageChange} />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        signUps: state.signUps,
        user: state.user,
        affiliates: state.affiliates
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(SignUps)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/SignUps.js